import classNames from 'classnames';
import { useDroppable } from "@dnd-kit/core";
import styles from "./LyricsDroppable.module.css";

const LyricsDroppable = ({children, id, accept, name, dragging}) => {
  const {isOver, setNodeRef} = useDroppable({
    id,
    data: {
      accept: accept,
    },
  });

  return (
    <span
      ref={setNodeRef}
      className={classNames(
        styles.Droppable,
        isOver && styles.over,
        dragging && styles.dragging,
        children && styles.dropped,
        styles.lyricsItem
      )}
      aria-label="Droppable region"
    >
      {children}
    </span>
  );
};

export default LyricsDroppable;
